import PropTypes from 'prop-types';

/**
 * PropTypes for data in choices component (select)
 */
export default PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })
);


// WEBPACK FOOTER //
// ./src/propTypes/choiceData.js